import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5279cdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "select-deal-type" }
const _hoisted_2 = { class: "q-pa-lg" }
const _hoisted_3 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_4 = {
  key: 0,
  class: "column q-px-lg no-wrap full-height"
}
const _hoisted_5 = { class: "col scroll" }
const _hoisted_6 = { class: "q-mt-xs q-pl-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t(`LEAD_CREATION_STEPS.STEP-${_ctx.step}`, { lead: _ctx.t('LEAD.LOW.SING') })), 1)
      ]),
      _: 1
    }, 16),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_iuf_select, _mergeProps({
        options: _ctx.dealTypeList,
        "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_SINGLE'),
        "onUpdate:modelValue": _ctx.selectDealType,
        onKeyup: _withKeys(_withModifiers(_ctx.goNextStep, ["stop"]), ["enter"]),
        autofocus: "",
        class: "full-width",
        clearable: "",
        "option-label": "name",
        "option-value": "dobjId",
        "selected-slot": ""
      }, _ctx.SELECT_SINGLE_LG, {
        modelValue: _ctx.selectedDealType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDealType) = $event))
      }), {
        option: _withCtx((props) => [
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, { class: "ellipsis" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.opt.name), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        selected: _withCtx(() => [
          (_ctx.selectedDealType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.selectedDealType.name) + " ", 1),
                _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedDealType.name), 1)
                  ]),
                  _: 1
                }, 16)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["options", "placeholder-value", "onUpdate:modelValue", "onKeyup", "modelValue"])
    ]),
    (_ctx.selectedDealType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _mergeProps({ class: "justified q-pb-md" }, _ctx.TEXT_CONTENT_BODY), _toDisplayString(_ctx.selectedDealType.description), 17),
          _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_HEADER_BODY)), _toDisplayString(_ctx.t('STAGES_TITLE')), 17),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedStages, (stage) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: stage.dobjId
                }, [
                  _createElementVNode("span", _mergeProps({ class: "ellipsis block" }, _ctx.TEXT_CONTENT_BODY), _toDisplayString(stage.name), 17)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}